import 'select2/dist/js/select2.full.js'

jQuery('.activity__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.tfg-content-members__select select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.pfts select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.nav-dropdown-mobile select').select2({
    width: '100%',
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.gform_wrapper select').select2({
    width: '100%'
})

jQuery('select.BBFormSelectList').select2({
    // width: '100%'
})

jQuery('.jobs__search select').select2({
    width: '100%'
});
jQuery('.jobs__sortby select').select2({
    width: '100%'
});
jQuery('#DISCIPLINE_IN').select2({
    escapeMarkup: function(markup) {
        return markup;
    },
    width: '100%', // Ensures dropdown uses full width
    dropdownAutoWidth: true
});

jQuery('.general__dropdown select').select2({
    width: '100%'
}).on('change', function () {
    window.location = jQuery(this).val()
})

jQuery(function() {
    jQuery('#data_table_wrapper > .dt-layout-row:first-child select').select2({
        width: '100%'
    })
    
})

jQuery(document).ready(function() {
    
});
